import React from "react";
import { useIntl } from "react-intl";
import { FormElement, Label } from "../../../../../components/Form";
import { IProps } from "./types";
import { getLabel } from "../../Components/IconedDetail";
import { choirRehearsalTypeOptions } from "../../../../consts/meta/details";
import messages from "../../../dashboard/Meta/Details/messages";

const uppercaseFirstCharacter = (text: string) => {
    return text.slice(0, 1).toUpperCase() + text.slice(1);
};

const RehearsalTimes = ({ rehearsals }: IProps) => {
    const { formatMessage, formatDate } = useIntl();
    if (rehearsals.length === 0) return null;
    return (
        <FormElement>
            <Label>{formatMessage(messages.rehearsals)}</Label>
            {rehearsals.map((rehearsal, i) => (
                <div key={i}>
                    {uppercaseFirstCharacter(formatDate(new Date(2024, 3, 1 + rehearsal.day), { weekday: "long" }))} {rehearsal.time.map(t => `0${t}`.slice(-2)).join(":")} - {formatMessage(getLabel(choirRehearsalTypeOptions, rehearsal.type))}
                </div>
            ))}
        </FormElement>
    );
};

export default RehearsalTimes;
